import React from 'react';
import {motion} from 'framer-motion';

const awards=[
  {year: '2024',name: 'AD100',org: 'Architectural Digest',image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=900&q=85'},
  {year: '2023',name: 'Best of Brooklyn',org: 'Dwell Magazine',image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=900&q=85'},
  {year: '2023',name: 'AIA Honor Award',org: 'American Institute of Architects',image: 'https://images.unsplash.com/photo-1600210491369-e753d80a41f3?auto=format&fit=crop&w=900&q=85'},
  {year: '2022',name: 'Ones to Watch',org: 'House Beautiful',image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=900&q=85'},
  {year: '2021',name: 'Design Rising',org: 'Elle Decor',image: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=900&q=85'},
  {year: '2020',name: 'Best Residential',org: 'IDA Awards',image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=900&q=85'}
];

function AwardsSection() {
  return (
    <section className="awards-section section-wrap" id="awards">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Recognition</p>
          <h2> Quietly,we've been <br /> <em>noticed.</em> </h2>
        </div>
      </div>
      <div className="awards-list">
        {awards.map((a,i)=> (
          <motion.div
            key={i}
            className="award-row"
            initial={{opacity: 0,y: 14}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true,amount: 0.4}}
            transition={{duration: 0.4,delay: i * 0.06}}
          >
            <span className="award-year">{a.year}</span>
            <span className="award-name">{a.name}</span>
            <span className="award-org">{a.org}</span>
            <div className="award-hover-image">
              <img src={a.image} alt={`${a.name} featured project`} loading="lazy" />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default AwardsSection;
